import { Container, Grid } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import HomeHeader from '../../redux/containers/home/HomeHeader';
import SummaryCard from '../../redux/containers/home/SummaryCard';
import TaskProgressList from '../../redux/containers/home/TaskProgressList';
import NavigationStatusCard from '../../redux/containers/navigation/NavigationStatusCard';
import NavigationStatusModal from '../../redux/containers/navigation/NavigationStatusModal';
import ActionBar from './ActionBar';

const styles = {
  container: {
    px: { xs: 1, sm: 2 },
    pt: { xs: 0.5, xl: 4 },
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  headerGrid: { mb: 2 },
  grid: { flexGrow: 1, pb: 2 },
  gridItemSummary: { display: 'flex' },
  gridItemList: { display: 'flex' },
};

export default function Home({ currentStore, getTasksProgress, getCategoryProgress, getCategoriesData, resetCategory }) {
  const [navOpen, setNavOpen] = useState(false);

  // Reload on every mount (navigation to Home) and on store change.
  // useEffect with [] runs once per mount — router unmounts Home when leaving.
  useEffect(() => {
    if (!currentStore) return;
    resetCategory();
    Promise.all([getTasksProgress(), getCategoriesData(), getCategoryProgress()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Also reload when store changes while Home is mounted (store selector in header).
  const prevStoreRef = useRef(currentStore);
  useEffect(() => {
    if (prevStoreRef.current === currentStore) return;
    prevStoreRef.current = currentStore;
    if (!currentStore) return;
    resetCategory();
    Promise.all([getTasksProgress(), getCategoriesData(), getCategoryProgress()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStore]);

  return (
    <Container maxWidth="xl" sx={styles.container}>

      {/* Header: full-width banner on mobile, banner + nav card on desktop */}
      <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ ...styles.headerGrid, alignItems: 'stretch' }}>
        <Grid item xs={12} md={8} sx={{ display: 'flex', alignItems: 'stretch', alignSelf: 'stretch' }}>
          <HomeHeader />
        </Grid>
        <Grid item xs={6} sx={{ display: { xs: 'flex', md: 'none' } }}>
          <SummaryCard />
        </Grid>
        <Grid item xs={6} md={4} sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'stretch' }}>
          <NavigationStatusCard onOpen={() => setNavOpen(true)} />
        </Grid>
        <Grid item md={4} sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'stretch' }}>
          <NavigationStatusCard onOpen={() => setNavOpen(true)} />
        </Grid>
      </Grid>

      <ActionBar />

      <Grid container spacing={{ xs: 2, sm: 3 }} sx={styles.grid}>
        <Grid item md={4} sx={{ ...styles.gridItemSummary, display: { xs: 'none', md: 'flex' } }}>
          <SummaryCard />
        </Grid>
        <Grid item xs={12} md={8} sx={styles.gridItemList}>
          <TaskProgressList />
        </Grid>
      </Grid>

      <NavigationStatusModal open={navOpen} onClose={() => setNavOpen(false)} />
    </Container>
  );
}
